// Building Trust
// Feedback on Google Reviews

import React from 'react';
import { Container, Col, Row} from 'react-bootstrap';
import Slider from "react-slick";
import StudentRev1 from "../../assets/hmpg_building_trust_reviews/shiva_s_rev1.webp";
import StudentRev2 from "../../assets/hmpg_building_trust_reviews/arijit_mallik_rev2.webp";
import StudentRev3 from "../../assets/hmpg_building_trust_reviews/ishani_ghosh_rev3.webp";
import StudentRev4 from "../../assets/hmpg_building_trust_reviews/Ajay_thanaji_mulik_rev4.webp";
import StudentRev5 from "../../assets/hmpg_building_trust_reviews/parna_dey_rev5.webp";
import StudentRev6 from "../../assets/hmpg_building_trust_reviews/liktha-rev6.webp";
import GoogleReview from "../../assets/hmpg_building_trust_reviews/google-review.webp";
import Rating from "../../assets/hmpg_building_trust_reviews/rating.webp";

const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };

function Section6() {
  return (
    <>
        <Container className='mycontainer'>
            <Row>
                <Col lg={12} className='text-center'>
                <div className='building_trust_hdings'>
                    <h2>Building Trust</h2>
                    <h5>Feedback on Google Reviews</h5>
                </div>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                <div className="slider-container">
                <Slider {...settings}>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev1} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Shiva S</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        Hi there, my name is Shiva Sudarshan.
                        My experience with East Point is "wow". We have received great support from
                        college faculties towards academics. We got encouragement to participate in
                        sports and cultural activities, thanks to the management for having that.
                        We have well experienced faculties. Advanced labs and good library where we can
                        explore with new creative knowledge.Coming to the best part of the college
                        experience is : Department of Training and Placement led by Dhananjay Sir. For
                        the last 2 years, he has been forcing (sometimes), encouraging and motivating us
                        to participate in various training, life-skill sessions, mock-test etc.
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev2} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Arijit Mallik</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        East Point College Of Nursing is a Very Good learning Hub , I am From Department
                        of Nursing .The College is very good a lots of well Qualified Staff & Faculty
                        members, They using Av Adis and modern Technology during Study Time .. Also
                        having lots of indoor and outdoor sports Facility Available here , Adequate
                        Laboratory facility. A good eco friendly campus ... which is more help ful to
                        gain our knowledge and gives a Bright Future to us
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev3} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Ishani Ghosh</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        East point group of institution is the place that allows you to have maximum
                        academics potential and also the co cirricular skills. It has more than 25 +
                        courses with the best infrastructure , healthy learning environments, separate
                        girls and boys hostel facilities , mess and good quality of food.
                        It also has specialized labs and well maintained hospital facility.
                        It also has a huge play arena , which has volleyball , basket ball , and cricket
                        grounds. This institution gives opportunity for showing the talents in all co
                        cirricular fields. I would conclude that coming in this college will be a
                        blessing in disguise
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev4} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Ajay Thanaji Mulik</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        I am a BPT final year student,Its really an amazing college to be a part of and
                        can be a great way to start and develop our future in this college.This college
                        is having good faculties and the infrastructure is very good. I have preferred
                        this college over others because it has very huge and amazing campus. It's an
                        environment friendly campus.
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev5} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Parna Dey</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        I am Parna dey, Student of East Point School of Nursing. I have secured 1st in
                        my Academics both in 1st year and 2nd year. East Point School of Nursing is
                        having a eco friendly campus and also a well equipped Hospital where we can
                        practice our skills and make us comprehensive in our profession. The teachers,
                        Principal and the Management are very supportive towards our future. I am happy
                        that I got a opportunity to be a part of East Point School of Nursing,
                        Bangalore.
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                    <div className='item review_container'>
                        <Row>
                            <Col lg={3} xs={3}>
                                <img src={StudentRev6} alt='Student 1 East Point' className='StudentImg w-100' />
                            </Col>
                            <Col lg={9} xs={9}>
                                <p className="StudentName">Liktha</p>
                                <img src={Rating} className='w-100 ratingimg' alt='East Point Rating' />
                            </Col>
                        </Row>
                        <p className='ellipsis'>
                        I am studying B- pharm ( 2nd year) in east point group of institute (EPCP) .
                        studying in this environment is like a blessing. Teaching is good. We get a lot
                        of motivation from lecturers. We come to see Humanity , opportunities
                        ,encouragement . Blessed to be a student of EPGI.❤️. Encouragement to hard work
                        , carrier related goals with extra curricular activities.
                
                        </p>
                        <div className='text-start'>
                            <p className='spanish-grey joey-bold font-18 mb-1 mt-3 text-start'>Posted</p>
                            
                            <a href="https://g.co/kgs/NRvC1Q" target="_blank" class="text-decoration-none">
                            <img src={GoogleReview}
                                className="googlereviewimg" loading="lazy"
                                alt="Google Review" /></a>
                            
                        </div>
                    </div>
                </Slider>
                </div>
                </Col>
            </Row>

        </Container>

        
        <div className='building_trust_reviews_container'>

        </div>
    </>
  )
}

export default Section6;